import { FC } from "react";

import { OAuthRedirectDesktopPageBase } from "@/pages/oauth-redirect-desktop/oauth-redirect-desktop-page-base";

export const IntegrationsSlackCallbackIosHandoffPage: FC = () => {
  return (
    <OAuthRedirectDesktopPageBase
      deepLinkPath="integrations/slack/callback"
      logPrefix="IntegrationsSlackCallbackIosHandoffPage"
    />
  );
};
